<div class="modal-content modal-content-right">
  <div class="modal-header">
    <h5 class="modal-title"><i class="fas fa-paperclip"></i>Send Schedule</h5>
    <button type="button" class="close" (click)="close()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div *ngIf="busy" class="modal-body text-center">
    <img src="./assets/images/preloader.gif" />
  </div>
  <div class="modal-body" *ngIf="!busy">
    <div class="form-group">
      <label>Invoice Number: </label>
      <div class="invoice_invoicenumber_text">
        {{ manualInvoiceModel.invoiceNumber }}
      </div>
    </div>

    <div class="form-group">
      <label>Customer Name: </label>
      <div>
        <span *ngIf="customerNameLoading"
          ><i class="fas fa-spinner fa-spin"></i></span
        ><strong
          *ngIf="!customerNameLoading"
          class="invoice_customername_text"
          >{{
            customerModel.CustomerName ? customerModel.CustomerName : "John Doe"
          }}</strong
        >
      </div>
    </div>

    <div class="form-group">
      <label>Schedule Date</label>
      <input
        type="date"
        class="form-control invoice_scheduleddate_input"
        [ngModel]="model.ScheduleDate | date: 'yyyy-MM-dd'"
        [ngClass]="{ 'is-invalid': !model.ScheduleDate }"
        (ngModelChange)="model.ScheduleDate = $event"
        [disabled]="isView"
        [min]="minDate.toISOString().split('T')[0]"
      />
    </div>
    <div class="form-group" *ngIf="model.Id > 0">
      <label>Schedule Status</label>
      <input
        type="text"
        class="form-control invoice_schedulestatus_input"
        placeholder=""
        disabled
        [(ngModel)]="model.ScheduleStatus"
        name="ScheduleStatus"
      />
    </div>
    <div class="form-group" *ngIf="model.Id > 0">
      <label>Sent Date</label>
      <input
        type="date"
        class="form-control invoice_sentddate_input"
        disabled
        [ngModel]="model.SentDate | date: 'yyyy-MM-dd'"
        required
        (ngModelChange)="model.SentDate = $event"
        name="SentDate"
      />
    </div>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      *ngIf="model.Id > 0 && !isView"
      data-toggle="modal"
      [disabled]="deleting || !model.ScheduleDate"
      (click)="deleteSchedule()"
      class="btn btn-outline invoice_deleteschedule_button"
    >
      <i class="fas fa-trash"></i
      ><span
        >&nbsp;Delete <i *ngIf="deleting" class="fas fa-spinner fa-spin"></i
      ></span>
    </button>
    <button
      type="button"
      *ngIf="!isView"
      data-toggle="modal"
      [disabled]="saving || !model.ScheduleDate"
      (click)="save()"
      class="btn btn-outline invoice_save_button"
    >
      <i class="fas fa-save"></i
      ><span
        >&nbsp;Save <i *ngIf="saving" class="fas fa-spinner fa-spin"></i
      ></span>
    </button>
  </div>
</div>
